import React from "react";
import PropTypes from "prop-types";
import CustomerFeedbackInputComponent from "../input/CustomerFeedbackInputComponent";
import {setupOnExtractData} from "../../../util/FormUtil";

class CustomerFeedbackComponent extends React.Component {
    constructor(props){
        super(props);
        this.state = {};
        this.setExtractData = this.setExtractData.bind(this);
    }

    componentDidMount() {
        setupOnExtractData(this);
    }

    setExtractData(func){
        this.extractData = func;
    }

    render(){
        const {data, metadata, setFormState, userDataInit} = this.props;
        return (
            <div className="grid">
                <div className="grid__col-md-3 grid__col-sm-12">
                    CME Group Research Panel
                    <p className={"paragraph--small"}>Join the CME Group Research Panel to provide valuable feedback (i.e. via surveys, interviews, demos, etc.) that will help us develop digital products, content, and experiences for customers like you.</p>
                </div>
                <div className="grid__col-md-9 grid__col-sm-12">
                    <CustomerFeedbackInputComponent
                        data={data}
                        metadata={metadata}
                        setFormState={setFormState}
                        userDataInit={userDataInit}
                        onExtractData={this.setExtractData}
                    />
                </div>
            </div>
        );
    }
}

CustomerFeedbackComponent.propTypes = {
    data: PropTypes.object.isRequired,
    metadata: PropTypes.object.isRequired,
    setFormState: PropTypes.func.isRequired,
    userDataInit: PropTypes.object.isRequired,
    onExtractData: PropTypes.func
};

export default CustomerFeedbackComponent;